import React from 'react';
import passIcon from '../../../../assets/icons/pass.svg';
import { passwordValidators } from '../../../../shared/constants/ResetPassword';

interface PasswordStrengthValidatorProps {
  password: string;
  onChange: (isValid: boolean) => void;
  className?: string;
}

type ValidationStage = 'notValidated' | 'failed' | 'passed';

const validate = (
  value: string,
  pattern: RegExp,
  validateWhen: number,
): ValidationStage => {
  if (value?.length >= validateWhen) {
    const isPassed = pattern.test(value);
    if (isPassed) return 'passed';
    return 'failed';
  }

  return 'notValidated';
};

function PasswordStrengthValidator({
  password,
  onChange,
  className,
}: PasswordStrengthValidatorProps) {
  const validatorStyles: Record<ValidationStage, string> = {
    passed: 'text-greene-600',
    failed: 'text-black-500',
    notValidated: 'ml-4 text-gray',
  };

  React.useEffect(() => {
    const isValid = passwordValidators.every(({ pattern }) =>
      pattern.test(password),
    );
    onChange(isValid);
  }, [onChange, password]);

  const validatorIcons: Record<ValidationStage, string | React.ReactNode> = {
    passed: passIcon,
    failed: <span className="w-3 text-lg text-black-500">•</span>,
    notValidated: '',
  };
  return (
    <div
      className={`grid grid-cols-2 items-start  justify-start text-xs ${className}`}
    >
      {passwordValidators.map(
        ({ label, pattern, noOfCharactersRequiredForValidation }) => {
          const validationStatus = validate(
            password,
            pattern,
            noOfCharactersRequiredForValidation,
          );
          return (
            <div className="mb-2 flex h-7 flex-row items-center justify-start gap-2">
              {validatorIcons[validationStatus] &&
                (typeof validatorIcons[validationStatus] === 'string' ? (
                  <img
                    src={validatorIcons[validationStatus] as string}
                    alt={validationStatus}
                    className="w-3"
                  />
                ) : (
                  validatorIcons[validationStatus]
                ))}
              <span
                key={label}
                className={`${validatorStyles[validationStatus]}`}
              >
                {label}
              </span>
            </div>
          );
        },
      )}
    </div>
  );
}

export default PasswordStrengthValidator;
